'use strict';

require('../../style/index.less');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/icon/style/index.js
// module id = 21
// module chunks = 0